import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '@/services/auth'

import LoginView from '../views/LoginView.vue'
import PainelView from '@/views/Dashboard/PainelView.vue'
import StockView from '@/views/Dashboard/Stock/StockView.vue'
import CategoryView from '@/views/Dashboard/Category/CategoryView.vue'
import CategoryNewView from '@/views/Dashboard/Category/NewView.vue'
import UsersView from '@/views/Dashboard/Users/UsersView.vue'
import UsersNewView from '@/views/Dashboard/Users/NewView.vue'
import ClientView from '@/views/Dashboard/Client/ClientView.vue'
import NewClientView from '@/views/Dashboard/Client/NewView.vue'
import RentalView from '@/views/Dashboard/Rental/RentalView.vue'
import SupplierView from '@/views/Dashboard/Supplier/SupplierView.vue'
import ItemNewView from '@/views/Dashboard/Stock/NewView.vue'
import NewRentalView from '@/views/Dashboard/Rental/NewView.vue'
import ClientDetailsView from '@/views/Dashboard/Client/DetailsView.vue'
import RentalDetailsView from '@/views/Dashboard/Rental/Details/DetailsView.vue'
import ItemDetailsView from '@/views/Dashboard/Stock/DetailsView.vue'
import SupplierNewView from '@/views/Dashboard/Supplier/NewView.vue'
import SupplierDetailsView from '@/views/Dashboard/Supplier/DetailsView.vue'
import UsersDetailsView from '@/views/Dashboard/Users/DetailsView.vue'
import RentalMovimentView from '@/views/Dashboard/Rental/RentalMovimentView.vue'
import DisponibilityView from '@/views/Dashboard/Stock/DisponibilityView.vue'
import TablePriceView from '@/views/Dashboard/TablePrice/TablePriceView.vue'
import TablePriceNewView from '@/views/Dashboard/TablePrice/NewView.vue'
import TablePriceDetailsView from '@/views/Dashboard/TablePrice/DetailsView.vue'
import ResumeView from '@/views/Dashboard/Operador/ResumeView.vue'
import ReportsView from '@/views/Dashboard/Reports/ReportsView.vue'
import MovementsView from '@/views/Dashboard/Movements/MovementsView.vue'

const routes = [
  {
    path: '/login', name: 'login',
    meta: { title: 'Login' },
    component: LoginView,
    beforeEnter: async (to, from, next) => {
      const auth = useAuth()
      if (auth.token && auth.user) {
        const valid = await auth.verifyToken()
        if (valid) {
          return next({ name: 'painel' });
        } else {
          auth.clearData();
        }
      }
      return next();
    }
  },
  { path: '/logout', name: 'logout',
    beforeEnter: (to, from, next) => {
      const auth = useAuth(); auth.logout(); next({ name: 'login' });
    }
  },
  //{ path: '/register', name: 'register', meta: { title: 'Register' }, component: RegisterView },
  { path: '/register', name: 'register', beforeEnter: (to, from, next) => { next({ name: 'login' }); }},
  { path: '/', name: 'painel', meta: { title: 'Painel', requiresAuth: true }, component: PainelView },

  //Endpoints para operadores
  { path: '/resume', name: 'resume', meta: { title: 'Resumo', requiresAuth: true }, component: ResumeView },
  
  { path: '/stock', name: 'stock', meta: { title: 'Estoque', requiresAuth: true }, component: StockView },
  { path: '/stock/details', name: 'stockdetails', meta: { title: 'Detalhes do Item', requiresAuth: true }, component: ItemDetailsView },
  { path: '/stock/new', name: 'stocknew', meta: { title: 'Novo Item - Estoque', requiresAuth: true }, component: ItemNewView },
  { path: '/client', name: 'client', meta: { title: 'Clientes', requiresAuth: true }, component: ClientView },
  { path: '/client/details', name: 'clientdetails', meta: { title: 'Detalhes Cliente', requiresAuth: true }, component: ClientDetailsView },
  { path: '/client/new', name: 'newclient', meta: { title: 'Cadastrar Cliente', requiresAuth: true }, component: NewClientView },
  { path: '/rental', name: 'rental', meta: { title: 'Locações', requiresAuth: true }, component: RentalView },
  { path: '/rental/details', name: 'rentaldetails', meta: { title: 'Detalhes da Locação', requiresAuth: true }, component: RentalDetailsView },
  { path: '/rental/new', name: 'newrental', meta: { title: 'Nova Locação', requiresAuth: true }, component: NewRentalView },
  { path: '/rental/moviment', name: 'rentalmoviment', meta: { title: 'Confirmar Movimentação', requiresAuth: true }, component: RentalMovimentView },
  { path: '/supplier', name: 'supplier', meta: { title: 'Fornecedores', requiresAuth: true }, component: SupplierView },
  { path: '/supplier/new', name: 'newsupplier', meta: { title: 'Novo Fornecedor', requiresAuth: true }, component: SupplierNewView },
  { path: '/supplier/details', name: 'supplierdetails', meta: { title: 'Detalhes Fornecedor', requiresAuth: true }, component: SupplierDetailsView },
  { path: '/category', name: 'category', meta: { title: 'Categorias', requiresAuth: true }, component: CategoryView },
  { path: '/category/new', name: 'categorynew', meta: { title: 'Nova Categoria', requiresAuth: true }, component: CategoryNewView },
  { path: '/users', name: 'users', meta: { title: 'Usuários', requiresAuth: true }, component: UsersView },
  { path: '/users/new', name: 'usersnew', meta: { title: 'Novo Usuário', requiresAuth: true }, component: UsersNewView },
  { path: '/users/details', name: 'usersdetails', meta: { title: 'Detalhes Usuário', requiresAuth: true }, component: UsersDetailsView },
  { path: '/stock/disponibility', name: 'verificar-disponibilidade', meta: { title: 'Verificar Disponibilidade', requiresAuth: true }, component: DisponibilityView },
  { path: '/tableprice', name: 'table-price', meta: { title: 'Tabelas de Preço', requiresAuth: true }, component: TablePriceView },
  { path: '/tableprice/new', name: 'table-price-new', meta: { title: 'Nova Tabela de Preços', requiresAuth: true }, component: TablePriceNewView },
  { path: '/tableprice/details', name: 'table-price-details', meta: { title: 'Detalhes da Tabela de Preço', requiresAuth: true }, component: TablePriceDetailsView },
  { path: '/reports', name: 'reports', meta: { title: 'Relatórios', requiresAuth: true }, component: ReportsView },
  { path: '/movements', name: 'movements', meta: { title: 'Movimentações', requiresAuth: true }, component: MovementsView }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from) => {
  const auth = useAuth()
  document.title = to.meta?.title ? `${to.meta.title} - ${process.env.VUE_APP_NAME}` : process.env.VUE_APP_NAME

  //Testa login
  if (to.meta?.requiresAuth) {
    if (auth.token && auth.user) {
      const valid = await auth.verifyToken()
      if (!valid) {
        auth.clearData();
        return { name: 'login' }; // token inválido → manda pro login
      }
    } else {
      return { name: 'login' };
    }
  }

  return true;
})

export default router
